import {
  Text,
  IconChevronDown,
  IconChevronTop,
  IndigoIndigo60,
  Primary13SemiBold,
  Box
} from '@sequencehq/core-components'
import { usePricingEditorDomainContext } from 'common/drawers/PricingEditor/communication'

export const useShowAdditionalFields = () => {
  const pricingEditorContext = usePricingEditorDomainContext()

  const updateShowAdditionalFields = (newState: boolean) => {
    pricingEditorContext.mutators.common.updateEditor({
      showAdditionalFields: newState
    })
  }

  return {
    showAdditionalFields:
      pricingEditorContext.queries.rawData.editor.showAdditionalFields,
    updateShowAdditionalFields
  }
}

export const ShowAdditionalFieldsToggle = () => {
  const { showAdditionalFields, updateShowAdditionalFields } =
    useShowAdditionalFields()

  return (
    <Box
      display="flex"
      gap="4px"
      alignItems="center"
      cursor="pointer"
      userSelect="none"
      data-testid="priceEditor.showAdditionalFields"
      onClick={() => updateShowAdditionalFields(!showAdditionalFields)}
    >
      <Text {...Primary13SemiBold} color={IndigoIndigo60}>
        Show additional fields
      </Text>
      {showAdditionalFields ? (
        <IconChevronTop
          data-testid="priceEditor.showAdditionalFields.hide"
          color={IndigoIndigo60}
          size={20}
        />
      ) : (
        <IconChevronDown
          data-testid="priceEditor.showAdditionalFields.show"
          color={IndigoIndigo60}
          size={20}
        />
      )}
    </Box>
  )
}
